module.exports = __webpack_public_path__ + "img/gittertraeger.fe69222e.svg";